import { render, staticRenderFns } from "./AmendantRecord.vue?vue&type=template&id=a28073bc&scoped=true"
import script from "./AmendantRecord.vue?vue&type=script&lang=js"
export * from "./AmendantRecord.vue?vue&type=script&lang=js"
import style0 from "./AmendantRecord.vue?vue&type=style&index=0&id=a28073bc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a28073bc",
  null
  
)

export default component.exports